import { useRef } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import type { ChainId } from '../sdk'
import { getActiveChainId } from '../config/active'
import {
  isBrowserPageReload,
  hasSwapEntryParamsInHash,
  pruneMobileSwapSessionForColdBoot,
  resolveMobileSwapBootRedirect,
  shouldResumeMobileSwapRoute,
} from '../domain/swap/mobileSwapBootRoute'
import { hasSwapFormDraft } from '../domain/swap/swapFormDraft'
import { readMobileSwapSession } from '../domain/swap/mobileSwapSession'
import store from '../state'

/**
 * Refuerzo en React tras boot-route.js (receipts persistidos en localStorage).
 */
export default function MobileSwapRouteBootstrap() {
  const location = useLocation()
  const bootstrapChecked = useRef(false)

  if (bootstrapChecked.current) return null
  bootstrapChecked.current = true

  const transactions = store.getState().transactions
  pruneMobileSwapSessionForColdBoot(transactions)

  const session = readMobileSwapSession()
  const chainTransactions = session ? transactions[session.chainId as ChainId] : undefined
  const resumeSwap = shouldResumeMobileSwapRoute(session, chainTransactions)
  const allowSwapEntry =
    hasSwapEntryParamsInHash() || hasSwapFormDraft(getActiveChainId())
  const redirectTo = resolveMobileSwapBootRedirect(location.pathname, resumeSwap, {
    isPageReload: isBrowserPageReload(),
    allowSwapEntry,
  })

  if (!redirectTo) return null
  return <Navigate to={redirectTo} replace />
}
